/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface CurriculumInfoPayload {
    careerId: string;
}

export interface CurriculumInfo {
    careerId: string;
    careerName: string;
    comment: string;
    credit: number;
    level: string;
    division: string;
    field: string;
    managementCode: string;
    organizer: string;
    outline: string;
    purpose: string;
    reference: string;
    referenceUrl: string;
    applicationPlace: string;
    completeJudgment: string;
    target: string;
    targetEmployeeDivisionName: string;
    targetEmployeeDivisionName1: string;
    targetEmployeeDivisionName2: string;
    targetEmployeeDivisionName3: string;
    targetEmployeeDivisionName4: string;
    targetEmployeeDivisionName5: string;
    targetOccupationName: string;
    targetOccupationName1: string;
    targetOccupationName2: string;
    targetOccupationName3: string;
    targetOccupationName4: string;
    targetOccupationName5: string;
    targetOfficeName: string;
    targetOfficeName1: string;
    targetOfficeName2: string;
    targetOfficeName3: string;
    targetOfficeName4: string;
    targetOfficeName5: string;
    targetOrganizeName: string;
    targetPostName: string;
    targetYoungWorker: string;
    targetSectionName1: string;
    targetSectionName2: string;
    targetSectionName3: string;
    targetSectionName4: string;
    targetSectionName5: string;
    targetPostName1: string;
    targetPostName2: string;
    targetPostName3: string;
    targetPostName4: string;
    targetPostName5: string;
    targetYoungWorker1: number;
    targetOldWorker: number;
}

export interface CurriculumInfoResponse {
    curriculumInfo: CurriculumInfo;
    useJinjiZokusei: string;
}

class CurriculumInfoService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "curriculumInfo");
    }

    public async fetch(payload: CurriculumInfoPayload): Promise<CurriculumInfoResponse> {
        return super.postWithPromise(payload).then((json: any) => json as CurriculumInfoResponse);
    }
}

export default CurriculumInfoService;
